import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/type";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import excel from "../../Assets/images/excel.png";
import closeIcon from "../../Assets/images/black-close-icon.png";
import { withStyles } from "@material-ui/styles";
import Button from "../../CommonElements/Button";
import blackCircle from "../../Assets/images/blackCircle.png";
import checkMark from "../../Assets/images/checkmark-icon.png";
import success from "../../Assets/images/success.png";
import warning from "../../Assets/images/warning.png";
import arrowback from "../../Assets/images/arrow-back.png";
import clsx from "clsx";
import { useStyles } from "./style";
import { BULK_UPLOAD_API_STATUS, BULK_UPLOAD_STATUS_VIEW } from "../../Constants/bulkUpload";

const CustomDialog = withStyles({
  root: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 706,
      width: 706,
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
    },
    "& .MuiPaper-rounded": {
      borderRadius: 4,
    },
  },
})(Dialog);

const BulkUploadSuccessModal = (): JSX.Element => {
  const classes: any = useStyles();

  const [status, setStatus] = useState<number>(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
  const [show, setShow] = useState(false);

  const { uploadBatchId, bulkUploadStatusDetails } = useSelector((state: RootState) => ({
    uploadBatchId: state.bulkUploadReducer.uploadBatchId,
    bulkUploadStatusDetails: state.bulkUploadReducer.bulkUploadStatusDetails,
  }));

  useEffect(() => {
    if (bulkUploadStatusDetails?.status === BULK_UPLOAD_API_STATUS.PROCESSING) {
      setStatus(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
    } else if (bulkUploadStatusDetails?.status === BULK_UPLOAD_API_STATUS.PROCESSED) {
      if (bulkUploadStatusDetails?.failed_entries > 0) {
        setStatus(BULK_UPLOAD_STATUS_VIEW.FAILURE);
      } else if (bulkUploadStatusDetails?.successful_entries === bulkUploadStatusDetails?.total_entries) {
        setStatus(BULK_UPLOAD_STATUS_VIEW.SUCCESS);
      }

      !show && setShow(true);
    }
  }, [bulkUploadStatusDetails]);

  useEffect(() => {
    if (uploadBatchId?.id) {
      setStatus(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
      setShow(true);
    }
  }, [uploadBatchId]);

  const handleClose = () => {
    setShow(false);
  };

  const renderBasedOnDownloadStatus = () => {
    switch (status) {
      case BULK_UPLOAD_STATUS_VIEW.PROCESSING:
        return (
          <div>
            <div className="flex  items-center justify-center ds-mt40">
              <div className="f6 fw6 flex flex-column justify-center items-center">
                <div className="flex justify-center items-center">
                  <img src={checkMark} loading="lazy" className="img " style={{ width: "28px", height: "28px" }} />
                </div>
              </div>
              <div className={classes.line}></div>
              <img src={blackCircle} loading="lazy" className="img" style={{ width: "28px", height: "28px" }} />
            </div>
            <div className="f6 fw6 flex justify-center items-center ds-mt12">
              <div className="green ds-mr60">Uploaded</div>
              <div>Processing...</div>
            </div>

            <div className="flex flex-column items-center justify-center ds-mt40">
              <div className="flex flex-column items-center justify-center ds-mt12 ds-mb40">
                <div className={clsx(classes.fileName, "fw5 f5 ds-mb24 flex items-center justify-center")}>
                  <img src={excel} loading="lazy" className="img ds-mr12" />
                  Processing {uploadBatchId.filename}
                </div>
                <div className="fw5 f5">This might take upto 2-10 Minutes</div>
                <div className="o-50 f5">You can close this we will process your catalogue at the </div>
                <div className="o-50 f5 "> backend and will let you know once it is done</div>
              </div>
              <Button
                className="secondary-cta ds-mb80"
                width="122px"
                height="48px"
                fontSize="18px"
                onClick={() => setShow(false)}
              >
                CLOSE
              </Button>
            </div>
          </div>
        );
      case BULK_UPLOAD_STATUS_VIEW.SUCCESS:
        return (
          <div>
            <div className="flex  items-center justify-center ds-mt60">
              <div className="f5">
                <img src={success} loading="lazy" className="img" />
              </div>
            </div>
            <div className="flex flex-column items-center justify-center ds-mt12 ds-mb40">
              <div className={clsx(classes.fileName, "fw5 f5 ds-mb24 flex items-center justify-center")}>
                <img src={excel} loading="lazy" className="img ds-mr12" />
                {uploadBatchId.filename}
              </div>
              <div className="fw6 f5 ">Congrats! Catalog Successfully Uploaded</div>
              <div className="o-50 f5">All Items uploaded/updated successfully</div>
              <Button
                className="secondary-cta ds-mb40 ds-mt60"
                width="122px"
                height="48px"
                fontSize="18px"
                onClick={handleClose}
              >
                CLOSE
              </Button>
            </div>
          </div>
        );
      case BULK_UPLOAD_STATUS_VIEW.FAILURE:
        return (
          <div>
            <div className="flex  items-center justify-center ds-mt60">
              <div className="f5">
                <img src={warning} loading="lazy" className="img" />
              </div>
            </div>
            <div className="flex flex-column items-center justify-center ds-mt12 ds-mb40">
              <div className={clsx(classes.fileName, "fw5 f5 ds-mb24 flex items-center justify-center")}>
                <img src={excel} loading="lazy" className="img ds-mr12" />
                {uploadBatchId.filename}
              </div>
              <div className="fw6 red f4">
                {`${bulkUploadStatusDetails.failed_entries} / ${bulkUploadStatusDetails.total_entries}`} items failed to
                upload, we encountered some error!
              </div>
              <div className="fw5 f6 ds-mt12 o-50">
                This error might have caused due to slow internet connection or incorrect data need to think
              </div>
              <div className="fw5 f6 o-50">Please download the error report for more details</div>
              <a
                href={bulkUploadStatusDetails.report_file}
                className=" flex items-center fw6 justify-center black f5 ds-mt12"
                download
              >
                Download Error Report
                <img src={arrowback} className="img ml2 " loading="lazy" />
              </a>
              <Button
                className="secondary-cta ds-mb40 ds-mt60"
                width="122px"
                height="48px"
                fontSize="18px"
                onClick={handleClose}
              >
                CLOSE
              </Button>
            </div>
          </div>
        );
    }
  };

  return (
    <CustomDialog open={show} maxWidth="sm" className="relative">
      <DialogContent>
        <IconButton
          color="primary"
          aria-label="Close Pop Up"
          component="span"
          className={classes.closeBtn}
          onClick={handleClose}
        >
          <img src={closeIcon} alt="close icon" loading="lazy" className="img h2" />
        </IconButton>
        <div className="ds-mt40 ml4 mb2 f3 fw6">Upload new catalog</div>
        {renderBasedOnDownloadStatus()}
      </DialogContent>
    </CustomDialog>
  );
};

export default BulkUploadSuccessModal;
